import moment from './moment.js'

export default {
  ...moment,
}
